import { loadFBX } from '../../Reusable/loadFBX.js'
import { Moves } from './Moves'

export class CharAnimation {
  static SharedCache = new Map()
  static moves = new Moves()
  constructor ({ parent }) {
    this.parent = parent
    this.lastPlayingMove = false
  }

  static async preload () {
    let preloadList = [
      'Mma Idle',
      'control standing idle',

      'Praying Knee',
      'Ymca Dance',

      'Hook 1',
      'Side Kick (2)',

      'jump',
      'running',
      'control jog backwards',
      'left strafe',
      'right strafe',

      'football jog forward diagonal (2)',
      'football jog forward diagonal',
      'football jog backward diagonal (2)',
      'football jog backward diagonal',

      'control turn left a bit',
      'control turn right a bit'
    ]
    let waiters = []
    for (let name of preloadList) {
      waiters.push(CharAnimation.preloadByName({ name }))
    }
    try {
      await Promise.all(waiters)
    } catch (e) {
      console.log(e)
    }
  }

  async setupWithMixer ({ mixer }) {
    let mmaIdle = await this.getActionByDisplayName({ name: 'Mma Idle', mixer })
    let standIdle = await this.getActionByDisplayName({ name: 'control standing idle', mixer })
    // let warmup = await this.getActionByDisplayName({ name: 'Warming Up', mixer })

    let peaceSkill1Name = 'Praying Knee'
    let peaceSkill2Name = 'Ymca Dance'

    let peaceSkillAction1 = await this.getActionByDisplayName({ name: peaceSkill1Name, mixer })
    let peaceSkillAction2 = await this.getActionByDisplayName({ name: peaceSkill2Name, mixer })

    let fightSkillAction1 = await this.getActionByDisplayName({ name: 'Hook 1', mixer })
    let fightSkillAction2 = await this.getActionByDisplayName({ name: 'Side Kick (2)', mixer })

    let jump = await this.getActionByDisplayName({ inPlace: true, name: 'jump', mixer })

    // let goingBack = await this.getActionByDisplayName({ inPlace: true, name: 'control run backwards', mixer })
    // let steppingBackFight = await this.getActionByDisplayName({ inPlace: true, name: 'control step backward fight', mixer })

    let runForward = await this.getActionByDisplayName({ inPlace: true, name: 'running', mixer })
    let runBack = await this.getActionByDisplayName({ inPlace: true, name: 'control jog backwards', mixer })
    let runLeft = await this.getActionByDisplayName({ inPlace: true, name: 'left strafe', mixer })
    let runRight = await this.getActionByDisplayName({ inPlace: true, name: 'right strafe', mixer })

    let goForwardLeft = await this.getActionByDisplayName({ inPlace: true, name: 'football jog forward diagonal (2)', mixer })
    let goForwardRight = await this.getActionByDisplayName({ inPlace: true, name: 'football jog forward diagonal', mixer })
    let goBackLeft = await this.getActionByDisplayName({ inPlace: true, name: 'football jog backward diagonal (2)', mixer })
    let goBackRight = await this.getActionByDisplayName({ inPlace: true, name: 'football jog backward diagonal', mixer })

    // let stepForward = await this.getActionByDisplayName({ inPlace: true, name: 'control go forward', mixer })
    // let stepBackward = await this.getActionByDisplayName({ inPlace: true, name: 'control go backward', mixer })
    // let stepLeft = await this.getActionByDisplayName({ inPlace: true, name: 'control go left', mixer })
    // let stepRight = await this.getActionByDisplayName({ inPlace: true, name: 'control go right', mixer })

    let turnLeft = await this.getActionByDisplayName({ inPlace: true, name: 'control turn left a bit', mixer })
    let turnRight = await this.getActionByDisplayName({ inPlace: true, name: 'control turn right a bit', mixer })

    let goingForward = runForward
    let goingBack = runBack
    let goingLeft = runLeft
    let goingRight = runRight

    let skillAction1 = peaceSkillAction1
    let skillAction2 = peaceSkillAction2
    // let vm = this
    let actionKeyMap = [
      {
        cmd: 'w',
        action: goingForward
      },
      {
        cmd: 'a',
        action: goingLeft
      },
      {
        cmd: 's',
        action: goingBack
      },
      {
        cmd: 'd',
        action: goingRight
      },
      {
        cmd: 'wa',
        action: goForwardLeft
      },
      {
        cmd: 'wd',
        action: goForwardRight
      },
      {
        cmd: 'sa',
        action: goBackLeft
      },
      {
        cmd: 'sd',
        action: goBackRight
      },
      {
        cmd: 'q',
        action: turnLeft
      },
      {
        cmd: 'e',
        action: turnRight
      },
      {
        cmd: 'r',
        type: 'doOnce',
        get action () {
          return skillAction1
        }
      },
      {
        cmd: 't',
        type: 'doOnce',
        get action () {
          return skillAction2
        }
      },
      {
        cmd: 'space',
        type: 'doOnce',
        get action () {
          return jump
        }
      },
      {
        cmd: 'rest',
        get action () {
          return idle
        }
      }
    ]

    let syncCmd = () => {
      if (isDown.forward && isDown.left) {
        btn.cmd = 'wa'
      } else if (isDown.forward && isDown.right) {
        btn.cmd = 'wd'
      } else if (isDown.backward && isDown.left) {
        btn.cmd = 'sa'
      } else if (isDown.backward && isDown.right) {
        btn.cmd = 'sd'
      } else if (isDown.forward) {
        btn.cmd = 'w'
      } else if (isDown.backward) {
        btn.cmd = 's'
      } else if (isDown.left) {
        btn.cmd = 'a'
      } else if (isDown.right) {
        btn.cmd = 'd'
      } else if (isDown.turnLeft) {
        btn.cmd = 'q'
      } else if (isDown.turnRight) {
        btn.cmd = 'e'
      } else if (isDown.action1) {
        btn.cmd = 'r'
      } else if (isDown.action2) {
        btn.cmd = 't'
      } else if (isDown.space) {
        btn.cmd = 'space'
      } else {
        btn.cmd = 'rest'
      }
    }

    let idle = standIdle
    mixer.stopAllAction()
    idle.repetitions = Infinity
    idle.play()

    this.parent.charReady = true
    this.parent.moodType = 'peaceful'

    let toggleFightMode = () => {
      let last = idle
      if (this.parent.moodType === 'fighting') {
        this.parent.moodType = 'peaceful'
        idle = standIdle

        // goingLeft = runLeft
        // goingRight = runRight
        // goingBack = runBack
        // goingForward = runForward

        skillAction1 = peaceSkillAction1
        skillAction2 = peaceSkillAction2
      } else if (this.parent.moodType === 'peaceful') {
        this.parent.moodType = 'fighting'
        idle = mmaIdle

        // goingLeft = stepLeft
        // goingRight = stepRight
        // goingForward = stepForward
        // goingBack = stepBackward

        skillAction1 = fightSkillAction1
        skillAction2 = fightSkillAction2
      }
      mixer.stopAllAction()
      idle.crossFadeFrom(last, 0.3, true)
      idle.play()
    }

    this.parent.addEventListener('toggle-fight', () => {
      toggleFightMode()
    })

    this.parent.addEventListener('play-move', async (event) => {
      try {
        let { move } = event.data
        let action = await this.getActionByDisplayName({ name: move.displayName, mixer })
        mixer.stopAllAction()
        if (this.lastPlayingMove) {
          this.lastPlayingMove.fadeOut(0.3)
        }
        action.repetitions = Infinity
        action.reset().fadeIn(0.3).play()
        this.lastPlayingMove = action
      } catch (e) {
        console.log(e)
      }
    })

    // this.viewCameraMode = 'face'
    // this.dispatchEvent('play-move', { move: { displayName: 'Warming Up' }, cb: () => {} })

    let isDown = {
      forward: false,
      backward: false,
      left: false,
      right: false,
      turnLeft: false,
      turnRight: false,
      action1: false,
      action2: false,
      space: false,
      modd: false
    }

    let btn = {
      isDownAny: false,
      lastCmd: '',
      _cmd: '',
      get cmd () {
        return btn._cmd
      },
      set cmd (v) {
        btn.lastCmd = btn._cmd
        btn._cmd = v
      },
      skip: false
    }


    let actionTimeoutID = 0
    let runCmd = () => {
      actionKeyMap.forEach((e) => {
        if (e.cmd !== btn.cmd) {
          e.action.fadeOut(0.5)
        }
      })
      let active = actionKeyMap.find(e => e.cmd === btn.cmd)
      if (active) {
        if (active.type === 'doOnce') {
          if (!active.action.isRunning()) {
            active.action.repetitions = 1
            mixer.stopAllAction()
            active.action.fadeIn(0.15).play()
            clearTimeout(actionTimeoutID)
            actionTimeoutID = setTimeout(() => {
              idle.crossFadeFrom(active.action, 0.23).play()
            }, active.action.duration * 1000 - 0.23 * 1000)
          }
        } else {
          if (!active.action.isRunning()) {
            clearTimeout(actionTimeoutID)
            mixer.stopAllAction()
            active.action.fadeIn(0.2).play()
          }
        }
      }
    }

    // let moveForward, moveLeft, moveRight, moveBackward = false
    var onKeyDown = async (event) => {
      btn.isDownAny = true
      switch ( event.keyCode ) {
        case 38: // up
        case 87: // w
          isDown.forward = true
          break;

        case 37: // left
        case 65: // a
          isDown.left = true
          break;

        case 40: // down
        case 83: // s
          isDown.backward = true
          break;

        case 39: // right
        case 68: // d
          isDown.right = true
          break;

        case 32: // space
          isDown.space = true
          break;

        case 82: // r
          isDown.action1 = true
          break;

        case 84: // t
          isDown.action2 = true
          break;

        case 81: // q
          isDown.turnLeft = true
          break;

        case 69: // e
          isDown.turnRight = true
          break;

        case 88: // x
          if (this.parent.mode === 'full') {
            toggleFightMode()
          }
          isDown.mood = true
          break;

        default:
          break
      }

      syncCmd()

      if (actionKeyMap.find(e => {
        return e.type === 'doOnce' && e.cmd === btn.cmd
      })) {
        btn.skip = true
      } else {
        btn.skip = false
      }

      runCmd()

      if (this.lastPlayingMove) {
        this.lastPlayingMove.fadeOut(0.15)
      }
    }

    var onKeyUp = async (event) => {
      btn.isDownAny = false
      // let skipFadeOut = false
      // let isDownCopy = JSON.parse(JSON.stringify(isDown))

      switch ( event.keyCode ) {
        case 38: // up
        case 87: // w
          isDown.forward = false
          break;

        case 37: // left
        case 65: // a
          isDown.left = false
          break;

        case 40: // down
        case 83: // s
          isDown.backward = false
          break;

        case 39: // right
        case 68: // d
          isDown.right = false
          break;

        case 81: // q
          isDown.turnLeft = false
          break;

        case 69: // e
          isDown.turnRight = false
          break;

        case 82: // r
          isDown.action1 = false
          break;

        case 84: // t
          isDown.action2 = false
          break;

        case 32:
          isDown.space = false
          break;

        case 88: // x
          isDown.mood = false
          break;

          default:
            break
      }

      syncCmd()

      if (btn.skip) {
        return
      }
      runCmd()
    }

    this.parent.addEventListener('go-forward', (v) => {
      if (v.data) {
        onKeyDown({ keyCode: 87 })
      } else {
        onKeyUp({ keyCode: 87 })
      }
    })

    this.parent.addEventListener('go-backward', (v) => {
      if (v.data) {
        onKeyDown({ keyCode: 83 })
      } else {
        onKeyUp({ keyCode: 83 })
      }
    })

    this.parent.addEventListener('go-left', (v) => {
      if (v.data) {
        onKeyDown({ keyCode: 65 })
      } else {
        onKeyUp({ keyCode: 65 })
      }
    })

    this.parent.addEventListener('go-right', (v) => {
      if (v.data) {
        onKeyDown({ keyCode: 68 })
      } else {
        onKeyUp({ keyCode: 68 })
      }
    })

    this.parent.addEventListener('turn-left', (v) => {
      if (v.data) {
        onKeyDown({ keyCode: 81 })
      } else {
        onKeyUp({ keyCode: 81 })
      }
    })

    this.parent.addEventListener('turn-right', (v) => {
      if (v.data) {
        onKeyDown({ keyCode: 69 })
      } else {
        onKeyUp({ keyCode: 69 })
      }
    })

    this.parent.addEventListener('key-r', (v) => {
      if (v.data) {
        onKeyDown({ keyCode: 82 })
      } else {
        onKeyUp({ keyCode: 82 })
      }
    })
    this.parent.addEventListener('key-t', (v) => {
      if (v.data) {
        onKeyDown({ keyCode: 84 })
      } else {
        onKeyUp({ keyCode: 84 })
      }
    })

    this.parent.addEventListener('key-x', (v) => {
      if (v.data) {
        onKeyDown({ keyCode: 88 })
      } else {
        onKeyUp({ keyCode: 88 })
      }
    })

    document.addEventListener( 'keydown', onKeyDown, false );
    document.addEventListener( 'keyup', onKeyUp, false );
  }
  prepAnimation ({ pose, mixer, inPlace }) {
    if ((pose && !pose.animations) || (!pose)) {
      return Promise.reject(new Error('no pose'))
    }
    return new Promise((resolve) => {
      let action = false
      pose.animations.forEach((clip) => {
        if (inPlace) {
          if (clip.tracks[0] && clip.tracks[0].name === 'mixamorigHips.position') {
            let values = clip.tracks[0].values
            for (var i = 0; i < values.length; i += 3) {
              values[i + 0] = 0
              // values[i + 1] = 0
              values[i + 2] = 0
            }
          }
        }

        action = mixer.clipAction(clip)
        action.duration = clip.duration
        action.mixer = mixer
        resolve(action)
      });
    })
  }

  async loadMoveByName ({ name }) {
    let move = CharAnimation.moves.find(e => e.displayName === name)
    if (!move) {
      console.log('cannot find ... ' + name)
    }
    // let moveObj = await this.loadMove(move)
    return move
  }

  async getActionByDisplayName ({ inPlace, name, mixer }) {
    let moveObj = await this.loadMoveByName({ name })
    let url = moveObj.url
    let actionFBX = await CharAnimation.loadFBX({ url })
    let actionObj = await this.prepAnimation({ inPlace, pose: actionFBX, mixer })
    return actionObj
  }

  static async preloadByName ({ name }) {
    let move = CharAnimation.moves.find(e => e.displayName === name)
    if (move) {
      return CharAnimation.loadFBX({ url: move.url })
    }
  }

  static async loadFBX ({ url }) {
    if (CharAnimation.SharedCache.has(url)) {
      return CharAnimation.SharedCache.get(url)
    }
    let actionFBX = await loadFBX(url)
    CharAnimation.SharedCache.set(url, actionFBX)
    return actionFBX
  }
}
